import { useLinkLogic } from '@/app/navigation/stack-links';
import { useSidebar } from '@/components/ui/Sidebar/SidebarContextProps';
import { cn } from '@/lib/utils';
import { LinkComponentProps, Link as RouterLink } from '@tanstack/react-router';
import { useCallback } from 'react';

export function StackLink({
  children,
  to,
  stack: preferredStack = 0,
  className,
  ...props
}: LinkComponentProps & { stack?: number }) {
  const stackTo = useLinkLogic()(to, false, preferredStack);

  const { isMobile, setOpenMobile } = useSidebar();

  // Close mobile drawer on navigation
  // Tech
  const handleClick = useCallback(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [isMobile, setOpenMobile]);

  return (
    <RouterLink
      {...props}
      className={cn('underline', className)}
      to={stackTo}
      onClickCapture={handleClick}
    >
      {children}
    </RouterLink>
  );
}
